import {loadPage} from '@/helpers/routing'

/**
 * screen a f7 alert on error.
 *
 * @param {Error} error - an error.
 * @param {Vue} element - the vue component.
 */
export const errorMessageAlert = (error, element) => {
  let that = element
  that.$f7.hidePreloader()
  if (error.response) {
    switch (error.response.status) {
      case 400:
        if (error.response.data) {
          if (error.response.data.error && error.response.data.errorDescription) {
            that.$f7.alert(error.response.data.errorDescription, error.response.data.error)
          } else if (error.response.data.statusText) {
            that.$f7.alert('', error.response.data.statusText)
          }
        } else {
          that.$f7.alert('', error.response.statusText)
        }
        break
      case 401:
        that.$bus.$emit('service:unset')
        that.$bus.$off('sendbox-filtered')
        that.$bus.$off('refresh-cache-bank-accounts')
        that.$bus.$off('refresh-cache-contacts')
        that.$bus.$off('refresh-cache-attachments')
        that.$bus.$off('refresh-cache-account-members')
        that.$bus.$off('refresh-inbox-list-cache')
        that.$bus.$off('refresh-inbox-on-seen')
        that.$bus.$off('logout')
        that.$bus.$emit('LogIn', false)
        that.$f7.alert('Please Log in again', 'Session finished')
        that.$engine.user.unload()
        loadPage(that, {url: '/login/'})
        break
      case 406:
        that.$f7.alert('Please, try to connect again', 'Session Failed')
        break
      case 409:
        that.$f7.alert('You will receive a new code', 'Code Expired')
        break
      /*
      * Plus de gestion custom du case 423 depuis l'activation de compte par lien (plus besoin d'un modal qui demande un code d'activation)
      */
      // case 423:
      //   that.$f7.modal({
      //     title: 'Activate Account',
      //     text: 'Please enter your activation code',
      //     afterText: '<input class="accountActivationInput2" type="text"><p class="blueConfirmationButtonActivationOK2">OK</p>',
      //     buttons: [
      //       {
      //         text: 'Cancel',
      //         onClick: function () {
      //           that.$$('.blueConfirmationButtonActivationOK2').off('click')
      //         }
      //       },
      //       {
      //         text: 'Reset code',
      //         onClick: function () {
      //           that.sendAnotherCode()
      //           that.$$('.blueConfirmationButtonActivationOK2').off('click')
      //         }
      //       }
      //     ]
      //   })
      //   that.$$('.blueConfirmationButtonActivationOK2').on('click', function (e) {
      //     that.$f7.closeModal()
      //     that.activateAccount(that.Dom7('.accountActivationInput2').val())
      //   })
      //   break
      case 424:
        that.$f7.alert('Please follow the activation link provided via email', 'Activation failed')
        break
      default:
        that.$f7.alert(error.response.data.errorDescription, error.response.data.error)
    }
  } else {
    that.$f7.alert('We will get it fixed as soon as we can.', 'Something went wrong with the Network')
    console.log(error, element)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/alert.js